/**
 * Waveform color palette for sequence clips.
 * Colors are assigned to clips to visually distinguish different sources.
 */
export const WAVEFORM_COLORS = [
    '#FF8BCB',
    '#367f3a',
    '#4FC3FF',
    '#FFB74D',
    '#FF6F6F',
    '#FFF176',
    '#3C3C3C',
    '#BCAAA4',
] as const;

export type WaveformColor = typeof WAVEFORM_COLORS[number];

/**
 * Assigns an unused color from the palette.
 * Returns the first color that is not in the usedColors set.
 * If all colors are used, cycles through them.
 */
export function assignWaveformColor(usedColors: Set<string>): WaveformColor {
    // Find first unused color
    for (const color of WAVEFORM_COLORS) {
        if (!usedColors.has(color)) {
            return color;
        }
    }
    // If all colors are used, return the first one (cycle)
    return WAVEFORM_COLORS[0];
}

/**
 * Gets all currently used waveform colors from clips in the store.
 */
export function getUsedWaveformColors(clips: Record<string, { waveformColor?: string }>): Set<string> {
    const used = new Set<string>();
    for (const clip of Object.values(clips)) {
        if (clip.waveformColor) {
            used.add(clip.waveformColor);
        }
    }
    return used;
}

